var render = function render(){
  var _vm$invoice, _vm$invoice$invoice, _vm$invoice2, _vm$invoice2$invoice, _vm$invoice3, _vm$invoice3$totals, _vm$invoice4, _vm$invoice5, _vm$invoice6, _vm$invoice6$invoice, _vm$invoice7, _vm$invoice7$totals, _vm$invoice8, _vm$invoice9, _vm$invoice9$invoice, _vm$invoice10, _vm$invoice10$totals, _vm$invoice11, _vm$invoice12, _vm$invoice13, _vm$invoice13$totals, _vm$invoice14, _vm$invoice15, _vm$invoice16;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen bg-gray-100"
  }, [_c('div', {
    staticClass: "mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-start mb-6 mdmax:flex-col gap-4"
  }, [_c('div', [_c('button', {
    staticClass: "text-sm text-neutral-600 hover:text-neutral-800 mb-2",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/invoices/invoices');
      }
    }
  }, [_vm._v(" ← Kembali ")]), _c('h1', {
    staticClass: "text-xl font-bold text-neutral-800"
  }, [_vm._v("Invoice Detail")]), _c('div', {
    staticClass: "text-sm text-neutral-500 mt-1"
  }, [_c('p', [_vm._v(_vm._s(((_vm$invoice = _vm.invoice) === null || _vm$invoice === void 0 ? void 0 : (_vm$invoice$invoice = _vm$invoice.invoice) === null || _vm$invoice$invoice === void 0 ? void 0 : _vm$invoice$invoice.invoice_number) || "-"))]), _c('p', [_vm._v(_vm._s(_vm.formatDate((_vm$invoice2 = _vm.invoice) === null || _vm$invoice2 === void 0 ? void 0 : (_vm$invoice2$invoice = _vm$invoice2.invoice) === null || _vm$invoice2$invoice === void 0 ? void 0 : _vm$invoice2$invoice.invoice_date)))])])]), _c('div', {
    staticClass: "flex gap-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium",
    on: {
      "click": _vm.downloadPdf
    }
  }, [_vm._v(" Download PDF ")])])]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"
  }, [_c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Customer")]), _c('p', {
    staticClass: "text-neutral-800 font-bold"
  }, [_vm._v(" " + _vm._s(_vm.customerInfo.customer_name || "-") + " ")]), _c('p', {
    staticClass: "text-neutral-500 text-sm"
  }, [_vm._v(" " + _vm._s(_vm.customerInfo.customer_address || "-") + " ")])]), _c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-2"
  }, [_vm._v("Totals")]), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Subtotal")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.formatCurrency(((_vm$invoice3 = _vm.invoice) === null || _vm$invoice3 === void 0 ? void 0 : (_vm$invoice3$totals = _vm$invoice3.totals) === null || _vm$invoice3$totals === void 0 ? void 0 : _vm$invoice3$totals.subtotal) || ((_vm$invoice4 = _vm.invoice) === null || _vm$invoice4 === void 0 ? void 0 : _vm$invoice4.subtotal) || ((_vm$invoice5 = _vm.invoice) === null || _vm$invoice5 === void 0 ? void 0 : _vm$invoice5.sub_total))))])]), _c('div', {
    staticClass: "flex justify-between items-center mt-1"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Discount (" + _vm._s(((_vm$invoice6 = _vm.invoice) === null || _vm$invoice6 === void 0 ? void 0 : (_vm$invoice6$invoice = _vm$invoice6.invoice) === null || _vm$invoice6$invoice === void 0 ? void 0 : _vm$invoice6$invoice.discount_percentage) || _vm.customerInfo.discount_percent || "0") + "%)")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.formatCurrency(((_vm$invoice7 = _vm.invoice) === null || _vm$invoice7 === void 0 ? void 0 : (_vm$invoice7$totals = _vm$invoice7.totals) === null || _vm$invoice7$totals === void 0 ? void 0 : _vm$invoice7$totals.discount_amount) || ((_vm$invoice8 = _vm.invoice) === null || _vm$invoice8 === void 0 ? void 0 : _vm$invoice8.discount_amount))))])]), _c('div', {
    staticClass: "flex justify-between items-center mt-1"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("VAT (" + _vm._s(((_vm$invoice9 = _vm.invoice) === null || _vm$invoice9 === void 0 ? void 0 : (_vm$invoice9$invoice = _vm$invoice9.invoice) === null || _vm$invoice9$invoice === void 0 ? void 0 : _vm$invoice9$invoice.vat_percent) || "-") + "%)")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.formatCurrency(((_vm$invoice10 = _vm.invoice) === null || _vm$invoice10 === void 0 ? void 0 : (_vm$invoice10$totals = _vm$invoice10.totals) === null || _vm$invoice10$totals === void 0 ? void 0 : _vm$invoice10$totals.vat_amount) || ((_vm$invoice11 = _vm.invoice) === null || _vm$invoice11 === void 0 ? void 0 : _vm$invoice11.vat_amount) || ((_vm$invoice12 = _vm.invoice) === null || _vm$invoice12 === void 0 ? void 0 : _vm$invoice12.vat_value))))])]), _c('div', {
    staticClass: "flex justify-between items-center mt-2"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Total")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.formatCurrency(((_vm$invoice13 = _vm.invoice) === null || _vm$invoice13 === void 0 ? void 0 : (_vm$invoice13$totals = _vm$invoice13.totals) === null || _vm$invoice13$totals === void 0 ? void 0 : _vm$invoice13$totals.grand_total) || ((_vm$invoice14 = _vm.invoice) === null || _vm$invoice14 === void 0 ? void 0 : _vm$invoice14.total_amount) || ((_vm$invoice15 = _vm.invoice) === null || _vm$invoice15 === void 0 ? void 0 : _vm$invoice15.total_price) || ((_vm$invoice16 = _vm.invoice) === null || _vm$invoice16 === void 0 ? void 0 : _vm$invoice16.total))))])])])]), _c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm mb-6"
  }, [_c('h2', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v("Resi Summary")]), _c('TableComponent', {
    attrs: {
      "columns": _vm.resiColumns,
      "list": _vm.resiTableData,
      "compact": ""
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'shipment_date' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(entry.shipment_date)) + " ")]) : column.field === 'total_price' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.total_price)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  })], 1), _c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm"
  }, [_c('h2', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" Payment Terms ")]), _c('p', {
    staticClass: "text-neutral-700 whitespace-pre-line"
  }, [_vm._v(_vm._s(_vm.customerInfo.payment_terms || "-"))])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }